import { VersionSummary } from '../../core/models/version-summary'
import { SystemFile } from '../../organisation/models/system-file'
import { Mappable, Mapped } from '../../rest/decorators/mapped'
import { RestQuery } from '../../rest/utilities/rest-query'

@Mapped({
  file: { format: SystemFile.create },
  vehicle_not_on_site: { property: 'vehicleNotOnSite' },
  close_down_code: { property: 'closeDownCode' },
  versions: {
    format: VersionSummary.create,
  },
})
export class JobSignature extends Mappable {
  id!: number
  file?: SystemFile
  name!: string
  email!: string
  vehicleNotOnSite!: boolean
  closeDownCode!: string
  versions?: VersionSummary

  static create<Data>(attrs: Data) {
    return new JobSignature().map(attrs)
  }
}

type Includes = 'file'

export class JobSignatureQuery extends RestQuery<
  undefined,
  undefined,
  Includes
> {}
